<template>
    <transition name="c-fade-transition">
        <div class="c-dialog-modal" v-if="isShown" v-click-outside="onClickOutside">
            <div class="c-dialog-modal__dialog" ref="dialog" @keyup.esc="onEscKey" tabindex="0">
                <button @click="exit()"
                        class="c-dialog-modal__dialog__exit c-button c-button--outline-colors-only">
                    <font-awesome-icon :icon="['fal', 'times']"></font-awesome-icon>
                </button>
                <div class="c-dialog-modal__dialog__content">
                    <div class="c-dialog-modal__dialog__title">
                        <template v-if="oops">
                            Oops!
                        </template>
                        <template v-else>
                            <slot name="title"></slot>
                        </template>
                    </div>
                    <div class="c-dialog-modal__dialog__description">
                        <slot name="content"></slot>
                    </div>
                    <div class="c-dialog-modal__dialog__buttons">
                        <template v-if="$slots['buttons']">
                            <slot name="buttons"></slot>
                        </template>
                        <template v-else>
                            <button type="button"
                                    @click="cancel()"
                                    class="c-dialog-modal__dialog__title__buttons__cancel c-button c-button--outline"
                                    v-if="!oops && !onlyOkButton">
                                {{cancelButton}}
                            </button>
                            <button type="button"
                                    @click="submit()"
                                    class="c-dialog-modal__dialog__title__buttons__submit c-button c-button--default">
                                {{submitButton}}
                            </button>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "base-dialog-modal",
        props: {
            onlyOkButton: {
                type: Boolean,
                default: false,
            },
            oops: {
                type: Boolean,
                default: false,
            },
            cancelButton: {
                type: String,
                default: 'Cancel'
            },
            submitButton: {
                type: String,
                default: function () {
                    if(this.oops || this.onlyOkButton)
                        return 'Okay';
                    else
                        return 'Submit';
                }
            },
            customHandleExit: {
                type: Boolean,
                default: false,
            },
            customHandleCancel: {
                type: Boolean,
                default: false,
            },
            customHandleSubmit: {
                type: Boolean,
                default: false,
            },
            exitOnClickOutside: {
                type: Boolean,
                default: true,
            },
            exitOnEscKey: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                isShown: false,
                timeout: null,
            }
        },
        methods: {
            show(duration) {
                if (this.timeout)
                    this.clearTimeout(timeout);
                this.isShown = true;
                if (duration)
                    this.timeout = setTimeout(this.hide, duration);
                this.$nextTick(() => this.$refs.dialog.focus());
            },
            hide() {
                this.isShown = false;
                this.$emit('hide');
            },
            exit() {
                this.$emit('exit');
                if (this.customHandleExit)
                    return;
                this.hide();
            },
            cancel() {
                this.$emit('exit');
                if (this.customHandleExit)
                    return;
                this.hide();
            },
            submit() {
                this.$emit('submit');
                if (this.customHandleSubmit)
                    return;
                this.hide();
            },
            onClickOutside() {
                if(this.exitOnClickOutside)
                    this.exit();
            },
            onEscKey() {
                if (this.exitOnEscKey)
                    this.exit();
            }
        },
    }
</script>

<style scoped>
</style>
